module.exports = __webpack_public_path__ + "static/media/captain_lod_2.b494813c.glb";